<template>
    <div>
        <div class="search-input">
            <Input v-model="title" placeholder="请输入题干" clearable/>
            <Input v-model="knowledgePoints" placeholder="请输入知识点关键词" clearable/>
            <Button type="primary" @click="handleSearch">搜索</Button>
        </div>
        <!-- <Badge :count="item.count" v-for="(item,i) in errorTopList" :key="i" >
            <a href="javascript:;" class="demo-badge">{{item.knowledgePointTitle}}</a>
        </Badge> -->
        <div class="point">
            <div v-for="(item,i) in errorTopList" :key="i" :class="[{'point-item':true},{'pointActive':currIndex ==i}]" @click="knowledgePointSearch(item,i)">
                <div>{{item.knowledgePointTitle}}</div>
                <div class="count">{{item.count}}</div>
            </div>
        </div>
        <Table
            stripe 
            :loading="loading"
            border
            :columns="columns"
            :data="knowledgeList"
            sortable="custom"
            ref="table"
        >
            <template slot-scope="{ row }" slot="title">
                <mavonEditor 
                    :boxShadow="false" 
                    styleEditor="min-height: 20px;width: auto;" 
                    :content="row.title" 
                    :subfield="false" 
                    :toolbarsFlag="false" 
                    previewBackground="#fff"
                    defaultOpen="preview" 
                />
            </template>
            <template slot-scope="{ row }" slot="action">
                <Button size="small" type="primary" @click="preview(row)" style="margin-right:5px;">查看</Button>
                <Button size="small"  type="success" @click="remove(row, 'list')" >移除</Button>
            </template>
        </Table>
        <Page
            style="margin: 20px 10px;position: static;"
            size="small"
            :pageNumber="searchForm.pageNumber"
            :pageSize="searchForm.pageSize"
            :pageSizeOpts="pageSizeOpts"
            :total="total"
            @changePageNumber="changePageNumber"
            @changePageSize="changePageSize"
        >
        </Page>
        <!-- 答题结果  :mask-closable="false"-->
        <Modal v-model="showResultModal" class="knowModal resultModal" width="800" :z-index="9999" :closable="false" on-cancel="handleReset">
            <div class="viewError">
                <div class="item-detail">
                    <questionSingleView v-if="currInfo.questionType === 1" :info='currInfo' :correctAnswer="currInfo.answer" :yourAnswer="currInfo.answer" :txtSolution="currInfo.txtSolution ? currInfo.txtSolution : ''" :videoSolution="currInfo.videoSolution"></questionSingleView>
                    <questionMultipleView v-if="currInfo.questionType === 2" :info='currInfo' :correctAnswer="currInfo.answer" :yourAnswer="currInfo.yourAnswer" :txtSolution="currInfo.txtSolution ? currInfo.txtSolution : ''" :videoSolution="currInfo.videoSolution"></questionMultipleView>
                    <questionJugleView v-if="currInfo.questionType === 3" :info='currInfo' :correctAnswer="currInfo.answer" :yourAnswer="currInfo.answer" :txtSolution="currInfo.txtSolution ? currInfo.txtSolution : ''" :videoSolution="currInfo.videoSolution"></questionJugleView>
                    <questionFillBlankView  v-if="currInfo.questionType === 4" :isFrom="1" :info='currInfo' :correctAnswer="currInfo.answer" :yourAnswer="currInfo.answer" :txtSolution="currInfo.txtSolution ? currInfo.txtSolution : ''" :videoSolution="currInfo.videoSolution"></questionFillBlankView>
                    <questionSubject v-if="currInfo.questionType === 5" :info='currInfo' :correctAnswer="currInfo.answer" :yourAnswer="currInfo.answer" :txtSolution="currInfo.txtSolution ? currInfo.txtSolution : ''" :videoSolution="currInfo.videoSolution"></questionSubject>
                    <div v-if="currInfo.questionType === 6">编程题</div>
                </div>
                <div　class="right">
                    <div class="top">
                        <div class="counts">
                            <div class="tit"><span>练习</span><span>{{currInfo.participateCount}}次</span></div>
                            <div class="tit"><span>正确</span><span>{{currInfo.correctCount}}次</span></div>
                        </div>
                        <div class="time">
                            <div>收录时间：{{currInfo.shouluTime}}</div>
                            <div>最后一次练习：{{currInfo.countTime}}</div>
                        </div>
                        <div class="btn" @click="remove(currInfo, 'detail')">从错题集移除</div>
                    </div>
                    <div class="k-point">知识点：<div v-for="(item,i) in currInfo.knowledgePoints" :key="i" :title="item.title">{{item.title}}</div></div>
                </div>
            </div>
        </Modal>
        <Modal v-model="showRemoveModal" :z-index="9999" :closable="false" title="提示">
            <div>确定将此题移除错题集吗？</div>
            <div slot="footer">
                <Button type="text" @click="showRemoveModal = false">取消</Button>
                <Button type="primary" @click="removeItem(currRemoveInfo, currFrom)">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import questionSingleView from './components/questionSingleView.vue'
import questionMultipleView from './components/questionMultipleView.vue'
import questionJugleView from './components/questionJugleView.vue'
import questionSubject from './components/questionSubject.vue'
import questionFillBlankView from './components/questionFillBlankView.vue'
import mavonEditor from './components/mavonEditor.vue'
import Page from './components/page.vue'
import util from '@/libs/util'
export default {
    components: { questionSingleView, questionMultipleView, questionJugleView, questionSubject, questionFillBlankView,Page, mavonEditor },
    props:{
        errorTopList:{
            type: Array,
            default:null
        }
    },
    data(){
        return{
            searchForm:{
                userId: '78945643221236152',
                pageNumber: 1,
                pageSize: 10,
            },
            showRemoveModal: false,
            pageSizeOpts: [10, 30, 50],
            total: 0,
            currInfo: {},
            knowledgeList: [],
            columns:[
                {
                    title: '题型',
                    width: 120,
                    key: "questionType",
                    align: "center",
                    tooltip: true,
                    render: (h, params) => {
                        let text
                        switch (params.row.questionType) {
                            case 1:
                                text = '单选题'
                            break;
                            case 2:
                                text = '多选题'
                            break;
                            case 3:
                                text = '判断题'
                            break;
                            case 4:
                                text = '填空题'
                            break;
                            case 5:
                                text = '主观题'
                            break;
                            case 6:
                                text = '编程题'
                            break;
                        }
                        return h("div", text);
                    }
                },
                {
                    title: '题干',
                    minwidth: 220,
                    key: "title",
                    align: "center",
                    tooltip: true,
                    slot: 'title'
                },
                {
                    title: '做错次数',
                    width: 120,
                    key: "questionCount",
                    align: "center",
                    tooltip: true
                },
                {
                    title: '收录时间',
                    width: 200,
                    key: "lastCollectionTime",
                    align: "center",
                    tooltip: true,
                    
                },
                {
                    title: "操作",
                    key: "action",
                    width: 260,
                    align: "center",
                    fixed: "right",
                    slot: "action"
                }
            ],
            currIndex: null,
            knowledgeId: '',

            knowledgePoints: '',
            title: '',
            loading: false,
            showResultModal: false,
            showResolutionBox:false,
            
            currResolution:'',
            timeSpend:'2分3秒',
            currRemoveInfo:{},
            currFrom: ''
        }
    },
    mounted(){
        this.init()

    },
    methods:{
        init(){
            this.userInfo = util.localGet('userInfo')
            this.searchForm.userId = this.userInfo.id
            this._getMistakesCollection(util.md5Encryption(this.searchForm))
        },
        knowledgePointSearch(item,i){
            this.currIndex = i
            this.searchForm.knowledgePointId = item.knowledgePointId
            this._getMistakesCollection(util.md5Encryption(this.searchForm))
        },
        handleSearch(){
            this.searchForm.knowledgePointTitle = this.knowledgePoints
            this.searchForm.title = this.title
            this._getMistakesCollection(util.md5Encryption(this.searchForm))
            console.log(this.searchForm)
        },
        // 列表
        async _getMistakesCollection(params){
            this.loading = true
            const res= await this.postTKRequest('/v1/getMistakesCollection',params,true)
            this.loading = false
            if(res.success){
                res.result.list.forEach(item => {
                    item.title = decodeURIComponent(item.title)
                    // item = util.titleDecrypt(item)
                })
                this.knowledgeList = res.result.list
                this.total = res.result.total
            }
        },
        async preview(row){
            let params = {
                userId: this.userInfo.id,
                questionId: row.questionId
            }
            util.md5Encryption(params)
            const res = await this.postTKRequest('/v1/getErrorQuestionDetails',params,true)
            if(res.success){
                res.result.shouluTime = util.timestampToDate(res.result.lastCollectionTime)
                res.result.countTime = util.countTime(res.result.lastCollectionTime)
                // util.titleDecrypt(res.result,true)
                res.result.title = decodeURIComponent(res.result.title)
                switch (res.result.questionType) {
                    case 1 :// 单选题
                        res.result.optionsA = decodeURIComponent(res.result.optionsA)
                        res.result.optionsB = decodeURIComponent(res.result.optionsB)
                        res.result.optionsC = decodeURIComponent(res.result.optionsC)
                        if(res.result.optionsD){
                            res.result.optionsD = decodeURIComponent(res.result.optionsD)
                        }
                        if(res.result.optionsE){
                            res.result.optionsE = decodeURIComponent(res.result.optionsE)
                        }
                        if(res.result.optionsF){
                            res.result.optionsF = decodeURIComponent(res.result.optionsF)
                        }
                    break;
                    case 2:// 多选题
                        res.result.optionsA = decodeURIComponent(res.result.optionsA)
                        res.result.optionsB = decodeURIComponent(res.result.optionsB)
                        res.result.optionsC = decodeURIComponent(res.result.optionsC)
                        if(res.result.optionsD){
                            res.result.optionsD = decodeURIComponent(res.result.optionsD)
                        }
                        if(res.result.optionsE){
                            res.result.optionsE = decodeURIComponent(res.result.optionsE)
                        }
                        if(res.result.optionsF){
                            res.result.optionsF = decodeURIComponent(res.result.optionsF)
                        }
                        res.result.yourAnswer = res.result.answer.split(',')
                    break;
                    case 3://判断题
                        if(res.result.answer=='对' || res.result.answer=='T'){
                            res.result.answer = 'A'
                        }else if(res.result.answer=='错' || res.result.answer=='F'){
                            res.result.answer = 'B'
                        }
                        break;
                    
                    case 4:// 填空
                        if(res.result.answerCount=='1'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answer = res.result.answerA.split(',')
                        }else if(res.result.answerCount=='2'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answer = (res.result.answerA + ',' + res.result.answerB).split(',')
                        }else if(res.result.answerCount=='3'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            res.result.answer = (res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC).split(',')
                        }else if(res.result.answerCount=='4'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            res.result.answerD = decodeURIComponent(res.result.answerD)
                            res.result.answer = (res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC + ',' + res.result.answerD).split(',')
                        }else if(res.result.answerCount=='5'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            res.result.answerD = decodeURIComponent(res.result.answerD)
                            res.result.answerE = decodeURIComponent(res.result.answerE)
                            res.result.answer = (res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC + ',' + res.result.answerD + ',' + res.result.answerE).split(',')
                        }
                    break;
                    case 5 || 6:
                        break;
                    case 6:
                        if (res.result.programmingType === 1 || 0) {
                            this.ossPath = res.result.programmingPath
                            this.isShowScratch = true
                        } 
                    break;
                }
                console.log(res.result)
                if(res.result.txtSolution){
                    console.log('res.result.txtSolution && ')
                    res.result.txtSolution = decodeURIComponent(res.result.txtSolution)
                }else{
                    res.result.txtSolution = ''
                }
                this.currInfo = res.result
                // console.log(this.currInfo)
            }
            this.showResultModal = true
        },
        handleReset(){
            this.showResultModal = false
        },
        remove(row, from){
            this.currFrom = from
            this.currRemoveInfo = row
            this.showRemoveModal = true
            
        },
        async removeItem(row,from){
            let params = {
                userId: this.userInfo.id,
                questionId: row.questionId
            }
            if(from === 'detail'){
                params.questionId = row.id
            }
            util.md5Encryption(params)
            const res = await this.postTKRequest('/v1/removeErrorQuestion',params,true)
            if(res.success){
                this.$Message.success('移除成功')
                if(from === 'detail'){
                    this.showResultModal = false
                    this.showRemoveModal = false
                    this._getMistakesCollection(util.md5Encryption(this.searchForm))
                }else{
                    this.showRemoveModal = false
                    this._getMistakesCollection(util.md5Encryption(this.searchForm))
                }
            }
        },
        pSigleFn(data){
            console.log(data,'单选题答案')
            this.singleAnwer = data
        },
        pMultipleFn(data){
            console.log(data,'多选题答案')
            this.multipleAnswer = data
        },
        pJugleFnFn(data){
            console.log(data,'判断题答案')
            this.jugleAnswer = data
        },
        pSubjectFn(data){
            console.log(data,'主观题答案')
            this.subjectAnswer = data
        },
        pFillFn(data){
            console.log('fill')
            console.log(data,'填空题答案')
            this.fillAnswer = data
        },
        showResolute(){
            this.showResolutionBox = !this.showResolutionBox
        },
        // 当前页变化
        changePageNumber(v) {
            this.searchForm.pageNumber = v
            this._getMistakesCollection(this.searchForm)
        },
        // 每页显示条数变化
        changePageSize(v) {
            this.searchForm.pageSize = v
            this._getMistakesCollection(this.searchForm)
        },
        
    }
}
</script>
<style lang="less" scoped>
.resolve{
    padding: 20px;
    .text{
        margin-bottom: 50px;
        div:first-child{
            font-size: 16px;
            color: #ffa200;
        }
        /deep/ img{
            max-width: 100%;
        }
    }
    .video{
        div:first-child{
            font-size: 16px;
            color: #ffa200;
        }
        /deep/ video{
            max-width: 100%;
        }
    }
    
}
.right-key{
    background-color: #eee;
    padding: 20px;
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    border-radius: 6px;
    span:nth-child(2){
        cursor: pointer;
    }
}
.search-input{
    margin-bottom: 30px;
    /deep/ .ivu-input-wrapper{
        width: 260px;
        margin-right: 15px;
    }
}
.point{
    display: flex;
    flex-wrap: wrap;
    margin:  20px 0;
    cursor: pointer;
    .point-item{
        display: inline-flex;
        align-items: center;
        height: 36px;
        line-height: 36px;
        padding: 0 15px;
        border-radius: 18px;
        border: 1px solid #ccc;
        margin-right: 15px;
        .count{
            padding: 0 15px;
            height: 20px;
            line-height: 20px;
            border-radius: 10px;
            margin-left: 10px;
            background-color: #F0F0F0;
        }
    }
    .pointActive{
        background-color: #FF9D00;
        border: none;
        color: #fff;
        .count{
            background-color: #F09400;
        }
    }

}
.resultModal{
    /deep/ .ivu-modal-footer{
        display: none;
    }
    .viewError{
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
        .item-detail{
            width: 68%;
            margin:20px 0;
            overflow: hidden;
            padding-left: 20px;
        }
        .right{
            width: 220px;
            .top{
                position: relative;
                width: 100%;
                border: 1px solid #ddd;
                padding: 0 10px;
                border-radius: 10px;
                font-size: 12px;
                padding-bottom: 40px;
                color: #999;
                .counts{
                    height: 86px;
                    width: 100%;
                    display: inline-flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #ddd;
                    .tit{
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        width: 50%;
                        height: 100%;
                        
                        span:last-child{
                            font-size: 20px;
                            color: #FF9D00;

                        }
                    }
                }
                .time{
                    padding: 10px;
                }
                .btn{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    color: #fff;
                    background-color: #FF9D00;
                    border-radius: 0 0 10px 10px;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
            .k-point{
                margin-top: 20px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                width: 100%;
                border: 1px solid #ddd;
                border-radius: 10px;
                padding: 20px;
                div{
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    padding: 0 10px;
                    height: 28px;
                    line-height: 28px;
                    border-radius: 14px;
                    border: 1px solid #ddd;
                    margin-top: 10px;
                }
            }
            
        }
    }
}
/deep/ .ivu-spin-fix{
    z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// src/views/practise/errorCollection.vue